export default __webpack_public_path__ + "static/media/qms_edit_quote_icon.df44ef90.svg";